export const SABRE_SAMPLE = ` 1 UA 456K 12DEC J EWRSFO HK1  600P  920P
 2 AA 100Y 15JUN F JFKLAX HK1  800A 1103A
 3 DL 200B 20JUL M ATLLHR HL2  530P  700A`;

export const AMADEUS_SAMPLE = ` 1 LH 401 C 20DEC 4 FRAJFK HK1 1015 1305
 2 AF 1234 Y 22DEC 6 CDGSIN HK2 2140 1655
 3 SQ 25 J 25DEC 2 SINLHR HL1 2355 0620`;

export const MULTI_SERVICE_SAMPLE = `*ABC123
 1.1SMITH/JOHN MR
 1.2SMITH/JANE MRS
 2  EK 202Y 09OCT FR JFKDXB HK2  1010P 705P/10OCT
 3  EK 201Y 20OCT SA DXBJFK HK2  820A 235P
 4 HHL EK HK2 DXB 10OCT-17OCT
   ATLANTIS THE PALM
   DELUXE OCEAN ROOM
   RATE AED1200.00
   CONF H889900
 5 CAR ZE HK1 DXB 10OCT-17OCT
   HERTZ
   SUV AUTOMATIC
   PU 10OCT 2100 DXB
   DO 17OCT 0600 DXB
   CONF C556677
 6 OTH XX HK1 DXB 12OCT
   DUBAI DESERT SAFARI
   PICKUP ATLANTIS THE PALM
   1500-2200
   CONF EXC112233
 7 OTH XX HK1 DXB
   MSC EURIBIA
   CRUISE
   SAILING 13OCT-17OCT
   CABIN 12034
   BALCONY
   CONF CRUISE99887
 8 9 AP NYC 2125550100
 9 9 APE JOHN.SMITH//EXAMPLE.COM
10 FA PAX 176-1234567890/ETEK/S2-3/P1
11 FA PAX 176-1234567891/ETEK/S2-3/P2`;

export function formatItineraryText(gds, segments) {
  const lines = [];
  lines.push(`FLIGHT ITINERARY  (${gds} format)`);
  lines.push("=".repeat(52));
  segments.forEach((s, i) => {
    lines.push("");
    lines.push(`${i + 1}. ${s.airline_name} ${s.airline_code}${s.flight_number}  [${s.status}]`);
    lines.push(`   ${s.date}  |  ${s.cabin_class} (${s.booking_class})`);
    lines.push(`   DEP  ${s.departure_time}  ${s.origin_name} (${s.origin_code})`);
    lines.push(`   ARR  ${s.arrival_time}  ${s.destination_name} (${s.destination_code})`);
  });
  return lines.join("\n");
}
